import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo } from 'react';
import { COLORS } from '@astrumu/core-ui-branding';
import Primary from '../Primary/index.js';
const PageLoader = memo(({ isLoading = true, backgroundColor, ...props }) => {
    if (isLoading) {
        return (_jsx("div", { "data-cy": "page-loader", css: css({
                position: 'fixed',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                background: backgroundColor || COLORS.defaultColors.primaryBackgroundColor,
                zIndex: 9999
            }), children: _jsx(Primary, { ...props, isLoading: isLoading }) }));
    }
    return null;
});
export default PageLoader;
//# sourceMappingURL=index.js.map